export const isElementScrollable = (el) => {
    return el.scrollHeight > el.clientHeight;
};
export const getFirstScrollableElement = ({ element, parentsToStop, }) => {
    if (element && parentsToStop.some(parent => parent?.contains(element))) {
        return isElementScrollable(element)
            ? element
            : getFirstScrollableElement({ element: element.parentElement, parentsToStop });
    }
    return null;
};
//# sourceMappingURL=useScrollBlock.utils.js.map